import { FC } from 'react';
import Send from '@assets/images/send.svg';

import useStyles from './styles';

export interface ICancelIcon {}

const CancelIcon: FC<ICancelIcon> = () => {
  const css = useStyles();
  return <img src={Send} className={css.image} />;
};

export default CancelIcon;
